import { State } from '../../types'

export const getTimestampStr = (state: State) => state.Clock.timestampStr
export const getTimestamp = (state: State) => state.Clock.timestamp
